"use client";

import * as React from "react";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { AccommodationTypeFilter } from "./AccommodationTypeFilter";
import { SEARCH_PARAMS } from "@/constants/api/search-params";

/**
 * Binds the accommodation-type popover to the repeatable `type` query param.
 * The picker itself stays presentational.
 */
export function TypeFilter({ className }: { className?: string }) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const selectedTypes = React.useMemo(
    () => searchParams.getAll(SEARCH_PARAMS.TYPE),
    [searchParams]
  );

  const handleSelect = (types: string[] | undefined) => {
    const params = new URLSearchParams(searchParams.toString());

    params.delete(SEARCH_PARAMS.TYPE);
    types?.forEach((type) => params.append(SEARCH_PARAMS.TYPE, type));

    // A new type selection invalidates the current page
    params.set(SEARCH_PARAMS.PAGE, "1");

    router.push(`${pathname}?${params.toString()}`);
  };

  return (
    <AccommodationTypeFilter
      className={className}
      selectedTypes={selectedTypes}
      onSelect={handleSelect}
    />
  );
}
